import React from "react";
import Arrow from "../Arrow/Arrow";
import Caret from "./Caret";
import * as styles from "./ExpandCollapseButton.module.css";

interface Props {
  handleClick: () => void;
  open: boolean;
  children: React.ReactChild;
}

export const ExpandCollapseButton: React.FC<Props> = ({
  handleClick,
  open,
  children,
  ...props
}) => {
  return (
    <button
      onClick={handleClick}
      className={styles.expandCollapseButton}
      type="button"
    >
      <span>
        <Arrow direction={open ? "down" : "right"} className={styles.arrow} />
      </span>
      {children}
    </button>
  );
};
